import Header from './components/Header';
import Hero from './components/Hero';
import Carousel from './components/Carousel';
import About from './components/About';
import Media from './components/Media';
import Cards from './components/Cards';
import Features from './components/Features';
import Comments from './components/Comments';
import Ranking from './components/Ranking';
import Updates from './components/Updates';
import Topics from './components/Topics';
import Index from './components/Index';
import Faq from './components/Faq';
import Contact from './components/Contact';
import AppEntry from './components/AppEntry';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <Hero />
        <Carousel />
        <About />
        <Media />
        <Cards />
        <Features />
        <Comments />
        <Ranking />
        <Updates />
        <Topics />
        <Index />
        <Faq />
        <Contact />
        <AppEntry />
      </main>

      <Footer />
    </>
  );
}